<template>
<div>
  <HeaderGestion/>
  <SubHeaderGestion
    nombreGestion="Tesis, seminarios, trabajos e informes técnicos"
  />
  <section>
    <FormTesisY/>
  </section>
</div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormTesisY from '../components/FormTesisY.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormTesisY },
  name: 'GesTesisY',
  data () {
    return {
      gestion: 'Gestión colecciones'
    }
  },
  methods: {
    goToGestion () {
      this.$router.push('/menuColecciones')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
